import React, { Component } from "react";
import Navbar from "./components/Navbar";
import Item from "./components/Item";
import Cart from "./components/Cart";
import "./App.css";
import itemsData from "./data/items";
import Login from "./components/Login";
class App extends Component {
  state = {
    items: [],
    searchItems: [],
    logged: false,
    status: false
  };
  async setData() {
    let _items = await itemsData();
    this.setState({
      items: _items,
      searchItems: _items,
      logged: true,
      status: false
    });

    console.log(this.state.items);
  }

  addHandler = id => {
    const { items, searchItems } = this.state;
    this.setState({
      items: items.map(item =>
        item.id === id ? { ...item, amount: item.amount + 1 } : { ...item }
      ),
      searchItems: searchItems.map(item =>
        item.id === id ? { ...item, amount: item.amount + 1 } : { ...item }
      )
    });
  };

  subHandler = id => {
    const { items, searchItems } = this.state;
    this.setState({
      items: items.map(item =>
        item.id === id && item.amount !== 0
          ? { ...item, amount: item.amount - 1 }
          : { ...item }
      ),
      searchItems: searchItems.map(item =>
        item.id === id && item.amount !== 0
          ? { ...item, amount: item.amount - 1 }
          : { ...item }
      )
    });
  };

  resetHandler = () => {
    const { items, searchItems } = this.state;
    this.setState({
      items: items.map(item =>
        item.amount !== 0 ? { ...item, amount: 0 } : { ...item }
      ),
      searchItems: searchItems.map(item =>
        item.amount !== 0 ? { ...item, amount: 0 } : { ...item }
      )
    });
  };

  resetItemHandler = id => {
    const { items, searchItems } = this.state;
    this.setState({
      items: items.map(item =>
        item.id === id ? { ...item, amount: 0 } : { ...item }
      ),
      searchItems: searchItems.map(item =>
        item.id === id ? { ...item, amount: 0 } : { ...item }
      )
    });
  };

  checkoutHandler = () => {
    alert(JSON.stringify(this.state.items.filter(item => item.amount > 0)));
  };

  searchHandler = event => {
    this.setState({
      searchItems: this.state.items.filter(item =>
        item.title.includes(event.target.value)
      )
    });
  };

  loginHandler = async (username, password) => {
    if (username === "admin" && password === "admin") {
      this.setState({
        status: true
      });
      this.setData();
    } else {
      alert("wrong Creditional");
    }
  };

  logoutHandler = () => {
    this.setState({
      logged: false
    });
  };
  render() {
    if (this.state.logged) {
      return (
        <div>
          <Navbar
            title="Shopping Cart"
            items={this.state.items.filter(item => item.amount > 0).length}
            search={this.searchHandler}
            logout={this.logoutHandler}
          />
          <div style={{ width: "80%", marginTop: "60px" }} className="inline">
            {this.state.searchItems.map(item => (
              <Item
                key={item.id}
                item={item}
                add={this.addHandler}
                sub={this.subHandler}
              />
            ))}
          </div>
          <div
            style={{ width: "20%", position: "fixed", marginTop: "60px" }}
            className="inline"
          >
            <Cart
              selectedItems={this.state.items.filter(item => item.amount > 0)}
              reset={this.resetHandler}
              checkout={this.checkoutHandler}
              resetItem={this.resetItemHandler}
            />
          </div>
        </div>
      );
    }
    return <Login login={this.loginHandler} logged={this.state.status} />;
  }
}

export default App;
